import { useState, createContext, useContext } from "react";

const SampleContext = createContext();

export function SampleProvider(props) {
  const [sample, setSample] = useState({
    foodMatrix: "",
    analyte: "",
    extractionSolvent: "",
    bulk: [],
    trace: [],
  });

  //
  const [bulks, setBulk] = useState();
  const [traces, setTrace] = useState();
  const [device, setDevice] = useState();

  const getLabel = (value, list) => {
    return list.find((item) => item.value === value)?.label;
  };

  const setCalibrationDevice = (calibrationDevice) => {
    setDevice(calibrationDevice);
  };

  const initBulk = (sequences) => {
    setBulk(
      sequences.map((item) => {
        return {
          date: item.date,
          findings: item.findings,
          deviceId: item.deviceId,
          sequenceId: item.sequenceId,
          library: item.library,
        };
      })
    );
  };

  const initTrace = (sequences) => {
    setTrace(
      sequences.map((item) => {
        return {
          date: item.date,
          findings: item.findings,
          deviceId: item.deviceId,
          sequenceId: item.sequenceId,
          library: item.library,
        };
      })
    );
  };

  const initWasatchBulk = (sequences) => {
    setSample({ ...sample, bulk: sequences });
  };

  const initWasatchTrace = (sequences) => {
    console.log("initWasatchTrace", sequences);
    setSample({ ...sample, trace: sequences });
  };

  // checks that newSequence is not in current sample bulk list, and adds it to list in sample state
  // similar to addTrace()
  const addBulk = (newSequence) => {
    if (
      sample.bulk.indexOf(
        (sequence) => sequence.sequenceId === newSequence.sequenceId
      ) === -1
    )
      setSample({ ...sample, bulk: [...sample.bulk, newSequence] });
  };

  // removes sequence from bulk list using sequenceId
  const removeBulk = (oldSequenceId) => {
    setSample({
      ...sample,
      bulk: [
        ...sample.bulk.filter(
          (sequence) => sequence.sequenceId !== oldSequenceId
        ),
      ],
    });
  };

  // see addBulk()
  const addTrace = (newSequence) => {
    if (
      sample.trace.indexOf(
        (sequence) => sequence.sequenceId === newSequence.sequenceId
      ) === -1
    )
      setSample({ ...sample, trace: [...sample.trace, newSequence] });
  };

  // removes sequence from trace list using sequenceId
  const removeTrace = (oldSequenceId) => {
    setSample({
      ...sample,
      trace: [
        ...sample.trace.filter(
          (sequence) => sequence.sequenceId !== oldSequenceId
        ),
      ],
    });
  };

  // reset all data for new sample
  const reset = () => {
    setSample({
      bulk: [],
      trace: [],
    });
  };

  return (
    <SampleContext.Provider
      value={{
        sample,
        setSample,
        getLabel,
        device,
        setCalibrationDevice,
        bulks,
        traces,
        initBulk,
        initTrace,
        initWasatchBulk,
        initWasatchTrace,
        addBulk,
        removeBulk,
        addTrace,
        removeTrace,
        reset,
      }}
    >
      {props.children}
    </SampleContext.Provider>
  );
}

export const useSampleContext = () => {
  const {
    sample,
    setSample,
    getLabel,
    device,
    setCalibrationDevice,
    bulks,
    traces,
    initBulk,
    initTrace,
    initWasatchBulk,
    initWasatchTrace,
    addBulk,
    removeBulk,
    addTrace,
    removeTrace,
    reset,
  } = useContext(SampleContext);
  return {
    sample,
    setSample,
    getLabel,
    device,
    setCalibrationDevice,
    bulks,
    traces,
    initBulk,
    initTrace,
    initWasatchBulk,
    initWasatchTrace,
    addBulk,
    removeBulk,
    addTrace,
    removeTrace,
    reset,
  };
};
